import { useState } from 'react';
import { postData } from '../api/apiService';

export const usePost = () => {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const postRequest = async (endpoint, requestData) => {
		setLoading(true);
		try {
			const { data } = await postData(endpoint, requestData);
			setData(data);
		} catch (error) {
			setError(error);
		} finally {
			setLoading(false);
		}
	};

	return { data, loading, error, postRequest };
};
